import { MedicalServiceNameForReceiptType } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { FieldControllerProps } from '@dreryk/react-common';
import { RadioGroup } from '@dreryk/react-components';

import { getReceiptTypes } from './MedicalServiceNameForReceiptTypeField.utils';

type MedicalServiceNameForReceiptTypeFieldProps = Omit<
   FieldControllerProps<'nameForReceiptType', MedicalServiceNameForReceiptType>,
   'required' | 'defaultValue'
>;

export const MedicalServiceNameForReceiptTypeField = (
   props: MedicalServiceNameForReceiptTypeFieldProps
): JSX.Element => {
   return (
      <RadioGroup
         controller={props.register(props.name)}
         defaultValue={'SAME_AS_STANDARD'}
         horizontal
         items={getReceiptTypes()}
         testId={props.name}
      />
   );
};
